<div class="banner">
  <div class="col-12 pb-5">
    <h1>My Short Codes</h1>
  </div>
  <div class="tab">
    <ul class="nav nav-tabs">
      <li>
        <a [routerLink]="[{ outlets: { 'my-shortcode-tab': ['shortcode-list'] } }]"
           [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }">Short Code List</a>
      </li>
      <li>
        <a [routerLink]="[{ outlets: { 'my-shortcode-tab': ['shortcode-needs-action'] } }]"
           [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }">Needs Action </a>
        <span *ngIf="needsActionCount && needsActionCount !== 0" id="needsActionBadge" class="badge rounded-pill">
              {{needsActionCount <= 99 ? needsActionCount : '&nbsp;!&nbsp;' }}
        </span>
      </li>
      <li *appNotAuthIf="[CognitoGroup.CarrierRegistrant, CognitoGroup.Carrier]">
        <a [routerLink]="[{ outlets: { 'my-shortcode-tab': ['shortcode-code-transfers'] } }]"
           [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }">Transfers</a>
        <span *ngIf="transferCount && transferCount !== 0" id="transfersBadge" class="badge rounded-pill">
             {{transferCount <= 99 ? transferCount : '&nbsp;!&nbsp;' }} 
        </span>
      </li>
      <ng-container *ngIf="cachedAccount.monBillEnabled || cachedAccount.monthlyInvoiceExists">
        <li *appNotAuthIf="[CognitoGroup.CarrierRegistrant, CognitoGroup.Carrier]">
          <a [routerLink]="[{ outlets: { 'my-shortcode-tab': ['shortcode-monthly-billing'] } }]"
             [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }">Monthly Invoices</a>
          <span *ngIf="invoiceCount && invoiceCount !== 0" id="monthlyInvoicesBadge" class="badge rounded-pill">
            {{invoiceCount <= 99 ? invoiceCount : '&nbsp;!&nbsp;' }}
          </span>
        </li>
      </ng-container>
      <li *ngFor="let tab of tabs">
         <a [routerLink]="[{ outlets: { 'my-shortcode-tab': tab.pathSegment } }]" [routerLinkActive]="['active']"
            [routerLinkActiveOptions]="{ exact: true }">
             {{ tab.tabType}}: {{ tab.objectId }}
           <button class="btn btn-sm btn-light"
             (click)="closeTab($event, tab.routeElement, tab.objectId);">X</button>
         </a>
      </li>
    </ul>
  </div>
</div>

<div class="tabcontent wide">
    <router-outlet (activate)="componentAdded($event)" name="my-shortcode-tab"></router-outlet>
</div>